// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Utils = require("./utils");
var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var Function$Rationale = require("rationale/src/Function.js");

((require('./Grid.css')));

var component = ReasonReact.statelessComponent("Grid");

var partial_arg = Function$Rationale.Infix[/* ||> */1];

function render_tiles(param) {
  return partial_arg((function (param) {
                return List.mapi((function (x, tile) {
                              var match = tile > 0;
                              return React.createElement("div", {
                                          key: "tile-" + (String(x) + ""),
                                          className: "Grid-tile tile-" + (String(tile) + "")
                                        }, Utils.render_string(match ? String(tile) : ""));
                            }), param);
              }), Utils.render_list, param);
}

var partial_arg$1 = Function$Rationale.Infix[/* ||> */1];

function render_rows(param) {
  return partial_arg$1((function (param) {
                return List.mapi((function (y, row) {
                              return React.createElement("div", {
                                          key: "row-" + (String(y) + ""),
                                          className: "Grid-row"
                                        }, render_tiles(row));
                            }), param);
              }), Utils.render_list, param);
}

function make(data, status, _children) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (_self) {
              return React.createElement("div", {
                          className: "Grid-container"
                        }, React.createElement("div", {
                              className: "Grid"
                            }, render_rows(data)), status !== 3 ? React.createElement("span", undefined) : React.createElement("div", {
                                className: "Grid-overlay"
                              }, React.createElement("div", {
                                    className: "Grid-overlay-message"
                                  }, Utils.render_string("game over"))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.component = component;
exports.render_tiles = render_tiles;
exports.render_rows = render_rows;
exports.make = make;
/*  Not a pure module */
